import React from 'react';
import { Zap, Battery, Wifi, Shield, Clock } from 'lucide-react';

const Products = () => {
  const products = [
    {
      id: 1,
      name: "Borne de Location JYA",
      image: "https://customer-assets.emergentagent.com/job_battery-hub-14/artifacts/3owwjp36_image.png",
      description: "Notre borne intelligente avec écran tactile et multiple slots pour batteries",
      features: [
        "Écran tactile intuitif",
        "Grande borne : 24 batteries",
        "Petite borne : 16 batteries",
        "Paiement sans contact",
        "Connexion 4G et WiFi intégrées"
      ]
    },
    {
      id: 2,
      name: "Batterie Portable JYA",
      image: "https://customer-assets.emergentagent.com/job_battery-hub-14/artifacts/4oihxfzd_image.png",
      description: "Batterie externe haute capacité avec charge rapide 22,5W - 100% en 20 minutes",
      features: [
        "Capacité : 8000mAh",
        "Charge rapide : 22,5W",
        "Rechargez à 100% en 20 min",
        "3 câbles intégrés",
        "Compatible tous smartphones"
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-yellow-50 via-white to-green-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 rounded-full border border-yellow-300 mb-4">
            <Zap className="w-4 h-4 text-yellow-600" />
            <span className="text-sm font-medium text-yellow-800">
              Nos Produits
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Technologie et Innovation
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Des équipements de pointe pour une expérience de recharge optimale
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {products.map((product, index) => (
            <div 
              key={product.id}
              className="group bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              {/* Image */}
              <div className="relative aspect-square bg-gradient-to-br from-gray-50 to-yellow-50 p-8 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-yellow-200/20 to-green-200/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <img 
                  src={product.image}
                  alt={product.name}
                  className="relative w-full h-full object-contain group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              
              {/* Content */}
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {product.description}
                </p>
                
                {/* Features */}
                <div className="space-y-3">
                  {product.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3 group/item">
                      <div className="w-2 h-2 bg-green-500 rounded-full group-hover/item:scale-150 transition-transform duration-300" />
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Battery className="w-6 h-6 text-yellow-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900">8000mAh</div>
                <div className="text-sm text-gray-600 mt-1">Capacité</div>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Zap className="w-6 h-6 text-green-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900">22,5W</div>
                <div className="text-sm text-gray-600 mt-1">Charge rapide</div>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Clock className="w-6 h-6 text-yellow-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900">20 min</div>
                <div className="text-sm text-gray-600 mt-1">100% chargé</div>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Wifi className="w-6 h-6 text-yellow-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900">4G + WiFi</div>
                <div className="text-sm text-gray-600 mt-1">Connectivité</div>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mx-auto mb-3">
                  <Shield className="w-6 h-6 text-green-600" />
                </div>
                <div className="text-2xl font-bold text-gray-900">CE/FC</div>
                <div className="text-sm text-gray-600 mt-1">Certifié</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
